<!-- 发布管理-预览软件版本 -->
<template>
  <div class="el-card__body">
    <div style="padding: 10px 20px 0 20px; float: right" v-if="!spilt&&softID!==0">
      <router-link target="_blank" 
      :to="{name: 'PublishDciViewSoftware', query: { softID: this.$Base64.encode(this.softID), indexName: this.$Base64.encode(this.indexName)}}"
      >弹出页面</router-link>
    </div>
    <div class="notice-index mb-10" v-if="indexName">
      <span style="font-size: small; color: #409eff"
        >&lt;&lt;{{ indexName }}
      </span>
    </div>
    <div class="notice-header mb-10" style="text-align: center">
      <h1>{{ item.PvName }}</h1>
      <div class="notice-author">
        <span
          v-if="item.PublishAt"
          style="margin-left: 100px；margin-right: 100px"
          >发布日期:{{ $sys.dateFormat(item.PublishAt, "Y-m-d") }}</span
        >
      </div>
    </div>
    <div v-if="item.Desc">
      <div style="padding-left: 15px; padding-bottom: 30px; font-size: 12px">
        版本说明：{{ item.Desc }}
      </div>
    </div>
    <div v-if="item.DciProductModels">
      <div
        style="
          padding-left: 15px;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        "
      >
        适用相关产品型号：
      </div>
      <div
        style="padding-left: 30px; padding-bottom: 5px; font-size: 14px"
        v-for="model in item.DciProductModels"
        :key="model.ID"
      >
        <li>{{ model.NameNumber }}</li>
      </div>
    </div>
    <div
      v-if="
        item.DciPvSoftwareVersions && item.DciPvSoftwareVersions.length !== 0
      "
    >
      <div
        style="
          padding-top: 30px;
          padding-left: 15px;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        "
      >
        相关版本程序：
      </div>
      <div
        style="padding-left: 30px; padding-bottom: 5px; font-size: 12px"
        v-for="(pv, index) in item.DciPvSoftwareVersions"
        :key="pv.ID"
      >
        <a
          target="_blank"
          style="color: #409eff; font-weight: bold"
          :href="pv.DownloadUrl"
          :download="getName(pv)"
          >{{ index + 1 }}.
          {{ pv.DciPvSoftware.DciPvSoftwareClassify.ClassName }}-{{
            pv.DciPvSoftware.SoftwareName
          }}-{{ pv.VersionName }}</a
        >&nbsp;&nbsp;&nbsp;
        <span v-if="pv.Desc">说明：{{ pv.Desc }} </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["softID", "indexName", "visible"],
  data() {
    return {
      item: {},
      spilt:false,
    };
  },
  mounted() {
    if (this.$route != undefined && this.$route.query != undefined && this.$route.query.softID != undefined) {
        this.softID = this.$Base64.decode(this.$route.query.softID)
        this.indexName = this.$Base64.decode(this.$route.query.indexName)
        this.spilt = true
    }
    this.onOpen();
  },
  methods: {
    onOpen() {
      if (this.softID != 0) {
        this.$axios
          .get(`dci/publish/software/${this.softID}`)
          .then((response) => {
            this.item = response.data;
          });
      }
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    getName(pv) {
      var name = pv.VersionName;
      if (pv.DownloadUrl) {
        var arr = pv.DownloadUrl.split("/");
        if (arr.length > 0) {
          name = arr[arr.length - 1];
        }
      }
      return name
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card__body {
  padding-top: 0;
  padding-bottom: 0;
  .notice-index {
    text-align: left;
    h1 {
      font-size: 20px;
    }
  }
  .notice-header {
    text-align: center;
    h1 {
      font-size: 20px;
      margin: 0 0 10px;
    }
    .notice-author {
      color: #888;
      font-size: 8px;
      padding-bottom: 10px;
    }
  }
  .notice-content {
    background: #fff;
    padding: 15px;
    img {
      max-width: 100%;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      th,
      td {
        border: 1px solid #888;
        padding: 3px 5px;
      }
    }
  }
  .el-upload-list__item-status-label {
    position: absolute;
    right: 5px;
    top: 0;
    line-height: inherit;
    display: none;
    visibility: hidden;
  }
  .el-upload-list__item .el-icon-close {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    opacity: 0.75;
    color: #606266;
    visibility: hidden;
  }
  .el-upload-list__item {
    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    font-size: 8px;
    color: #606266;
    line-height: 1.8;
    margin-top: 5px;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
    width: 100%;
  }
}
</style>